import { Cap } from '../../primitives'
import { EdgeRow } from './EdgeRow'
import { MonoRef } from './MonoRef'
import type { Step } from './tree'

/** One question in full: wording, how it's answered, and where each answer goes. */
export function StepBlock({ step }: { step: Step }) {
  return (
    <div className="flex flex-col gap-4">
      {step.asks.length > 0 && (
        <div className="flex flex-col gap-1.5">
          {step.asks.map((ask) => (
            <div key={ask.text} className="bg-ink-50 text-ink rounded-sm px-3 py-2 text-sm">
              {ask.when && <Cap className="mb-1">{ask.when}</Cap>}
              {ask.text}
            </div>
          ))}
        </div>
      )}

      <div>
        <Cap>Answered with</Cap>
        <div className="text-ink mt-1.5 text-sm">{step.collected}</div>
      </div>

      {step.options && (
        <div>
          <Cap>Options</Cap>
          <ul className="mt-2 flex flex-col gap-1.5">
            {step.options.map((option) => (
              <li key={option} className="flex items-start gap-2">
                <span className="border-ink-300 mt-1.5 size-2 shrink-0 rounded-sm border" />
                <span className="text-ink text-sm">{option}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {step.onlyWhen && (
        <div>
          <Cap>Only asked when</Cap>
          <div className="text-ink mt-1.5 text-sm">{step.onlyWhen}</div>
        </div>
      )}

      <div>
        <Cap>Answers</Cap>
        <ul className="border-ink-100 mt-2 ml-1 flex flex-col gap-1.5 border-l pl-4">
          {step.edges.map((edge) => (
            <EdgeRow key={`${edge.label}-${edge.to}`} edge={edge} />
          ))}
        </ul>
      </div>

      {step.behindTheScenes && (
        <div>
          <Cap>Behind the scenes</Cap>
          <div className="text-ink-500 mt-1.5 text-xs leading-relaxed">{step.behindTheScenes}</div>
        </div>
      )}

      <div className="border-ink-100 flex flex-wrap items-center gap-x-3 gap-y-1 border-t pt-3">
        <MonoRef value={step.service} />
        <MonoRef value={step.component} />
      </div>
    </div>
  )
}
